// extracted by mini-css-extract-plugin
export default {"partnerUploadsTable":"partner-uploads-table_partnerUploadsTable__oEbG+","tableButton":"partner-uploads-table_tableButton__TJoqz"};